import { Text } from '@mantine/core';
import React from 'react';

interface ChipComponentProps {
  status: string;
  color: string;
  bgColor: string;
}

const ChipComponent: React.FC<ChipComponentProps> = ({ status, color, bgColor }) => {
  return (
    <div
      style={{
        display: 'flex'
      }}
    >
      <div
        style={{
          backgroundColor: bgColor,
          color: color,
          borderRadius: '20px',
          padding: '5px 10px'
        }}
      >
        <Text fw={700} size='xs'>
          {status}
        </Text>
      </div>
    </div>
  );
};

export default ChipComponent;
